export enum NotificationStatus {
  NotRead = 1,
  Read = 2,
}
